import React from 'react';
import MarkdownWithViz from '../../MarkdownWithViz';

const reqPrefix = 'src/markdowns/tos';
const req = require.context('!raw-loader!../../../markdowns/tos', false, /\.(md|jsx)$/);

export default function ToS() {
  return <MarkdownWithViz req={req} reqSource={req} reqPrefix={reqPrefix} />;
}
